<template>
    <div>
      
      <Header active="navId"></Header>
      
      <div class="contain " style="margin: 50px auto;">
        <el-card class="box-card" v-loading="loading">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'Article', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <ul class="article" v-if="list && list.total>0">
            <li v-for="item in list.data"><router-link :to="{ name: 'ArticleInfo', params: {id: item.id}, query: {nav_id: navId}}"><span class="tit">{{item.title}}</span></router-link></li>
          </ul>
          <div class="page">
          <el-pagination
            background
            @current-change="handleCurrentChange"
            layout="prev, pager, next"
            :total="list.total" v-if="list && list.total>0">
          </el-pagination>
          <div  v-else description="暂无数据">暂无数据</div>

        </div>
        </el-card>
        
      </div>
  
      <Footer></Footer>
    </div>
  </template>
  
  <script>
  import Header from '@/components/header'
  import Footer from '@/components/footer'  
  import { article as articleApi } from '@/api/index'
  export default {
    data() {
      return {
        navId: '',
        nav: null,
        list: null,
        loading: true,
        page: 1,
        last_page: 0
      };
    },
    components: {
      Header, Footer
    },
    created(){
      this.navId = this.$route.query.nav_id
      this.getList()
    },
    methods: {
      getList(){
        articleApi({nav_id: this.navId, page: this.page}).then(res=> {
          this.loading = false
          this.nav = res.nav
          this.list = res.list
          this.page = res.list.current_page
          this.last_page = res.list.last_page
        })
      },
      handleCurrentChange(e){
        this.page = e
        this.getList()
      }
    },
  };
  </script>
  
  <style scoped>
  .article{
    padding: 0 20px;
  }
  .page {
    margin: 20px;
    text-align: center;
  }
 
  </style>
  